import React, { useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import { NavType, setActiveNavTab } from "../reducer/uiReducer";

interface useOnLoadPageProps {
  tabVisibility?: boolean;
  tabActive?: NavType;
  onFocus?: () => void;
  onBlur?: () => void;
}

export default function useOnLoadPage(screenData: useOnLoadPageProps) {
  const dispatch = useDispatch();
  const { tabVisibility, onFocus, tabActive } = screenData;

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
    tabActive && dispatch(setActiveNavTab(tabActive));
  }, [tabVisibility, tabActive, onFocus]);
}
